module.exports = "data:image/webp;base64,UklGRnIAAABXRUJQVlA4IGYAAAAwBACdASoZABkAPpE+mkkloyIhKAqosBIJZ1efWSaK4N/z2L4JQVVQ1gAA/vXgQY42WCzzZ5BYsJthsWeYDTSmlcWxOW7o0vQn7vbC4/HCBBki7EoR7TH/8A+Pkesc+ZBfnisbAAA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/sundust-ws.webp
// module id = ahca
// module chunks = 14